/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface FolderValidationBody {
  propertyType: FolderValidationBody.PropertyTypeEnum;
  documentTypes: Array<FolderValidationBody.DocumentTypesEnum>;
}
export namespace FolderValidationBody {
  export type PropertyTypeEnum = 'HOUSE' | 'HOUSE_AND_DEPEDENCIES' | 'APPARTMENT' | 'TERRAIN' | 'TERRAINS' | 'BUILDING';
  export const PropertyTypeEnum = {
    HOUSE: 'HOUSE' as PropertyTypeEnum,
    HOUSEANDDEPEDENCIES: 'HOUSE_AND_DEPEDENCIES' as PropertyTypeEnum,
    APPARTMENT: 'APPARTMENT' as PropertyTypeEnum,
    TERRAIN: 'TERRAIN' as PropertyTypeEnum,
    TERRAINS: 'TERRAINS' as PropertyTypeEnum,
    BUILDING: 'BUILDING' as PropertyTypeEnum,
  };
  export type DocumentTypesEnum =
    | 'COMP'
    | 'ACTE'
    | 'TITRE'
    | 'EHYP'
    | 'CAD'
    | 'CAD-REDUIT'
    | 'RU'
    | 'PEB'
    | 'PEB_COMMUN'
    | 'DECOM'
    | 'CI'
    | 'REG'
    | 'ELEC'
    | 'BDES'
    | 'MAIN'
    | 'GARAN'
    | 'VENTE'
    | 'DEPOT'
    | 'BAIL'
    | 'CERTI'
    | 'OVAM'
    | 'CRED'
    | 'ACTE_CRED'
    | 'ACTE_MAND'
    | 'EH_COMPL'
    | 'EH_DEMANDE'
    | 'OTHER'
    | 'IBGE'
    | 'ARTICLE90'
    | 'COMP_SIGNE'
    | 'ACTE_MAIN'
    | 'OFFRE'
    | 'MAP'
    | 'WATERTOETS'
    | 'ASBEST'
    | 'REGISTER'
    | 'ERFGOED'
    | 'CRF'
    | 'RVV'
    | 'BCE'
    | 'PLAN_CAD'
    | 'DOC_SYNDIC'
    | 'ACTE_BASE'
    | 'ANNEX_BASE'
    | 'ETAT_LIEUX'
    | 'GARANTIE_LOC'
    | 'ACTE_HEREDITE'
    | 'DEMANDE_RU'
    | 'DECLA_SUCC'
    | 'PERMIS_URB'
    | 'PERMIS_ENV'
    | 'REG_BENEF'
    | 'MAATREGELEN'
    | 'AR_REC'
    | 'LETTRE_VENTE'
    | 'ANB'
    | 'SCHEMA_UNIF';
  export const DocumentTypesEnum = {
    COMP: 'COMP' as DocumentTypesEnum,
    ACTE: 'ACTE' as DocumentTypesEnum,
    TITRE: 'TITRE' as DocumentTypesEnum,
    EHYP: 'EHYP' as DocumentTypesEnum,
    CAD: 'CAD' as DocumentTypesEnum,
    CADREDUIT: 'CAD-REDUIT' as DocumentTypesEnum,
    RU: 'RU' as DocumentTypesEnum,
    PEB: 'PEB' as DocumentTypesEnum,
    PEBCOMMUN: 'PEB_COMMUN' as DocumentTypesEnum,
    DECOM: 'DECOM' as DocumentTypesEnum,
    CI: 'CI' as DocumentTypesEnum,
    REG: 'REG' as DocumentTypesEnum,
    ELEC: 'ELEC' as DocumentTypesEnum,
    BDES: 'BDES' as DocumentTypesEnum,
    MAIN: 'MAIN' as DocumentTypesEnum,
    GARAN: 'GARAN' as DocumentTypesEnum,
    VENTE: 'VENTE' as DocumentTypesEnum,
    DEPOT: 'DEPOT' as DocumentTypesEnum,
    BAIL: 'BAIL' as DocumentTypesEnum,
    CERTI: 'CERTI' as DocumentTypesEnum,
    OVAM: 'OVAM' as DocumentTypesEnum,
    CRED: 'CRED' as DocumentTypesEnum,
    ACTECRED: 'ACTE_CRED' as DocumentTypesEnum,
    ACTEMAND: 'ACTE_MAND' as DocumentTypesEnum,
    EHCOMPL: 'EH_COMPL' as DocumentTypesEnum,
    EHDEMANDE: 'EH_DEMANDE' as DocumentTypesEnum,
    OTHER: 'OTHER' as DocumentTypesEnum,
    IBGE: 'IBGE' as DocumentTypesEnum,
    ARTICLE90: 'ARTICLE90' as DocumentTypesEnum,
    COMPSIGNE: 'COMP_SIGNE' as DocumentTypesEnum,
    ACTEMAIN: 'ACTE_MAIN' as DocumentTypesEnum,
    OFFRE: 'OFFRE' as DocumentTypesEnum,
    MAP: 'MAP' as DocumentTypesEnum,
    WATERTOETS: 'WATERTOETS' as DocumentTypesEnum,
    ASBEST: 'ASBEST' as DocumentTypesEnum,
    REGISTER: 'REGISTER' as DocumentTypesEnum,
    ERFGOED: 'ERFGOED' as DocumentTypesEnum,
    CRF: 'CRF' as DocumentTypesEnum,
    RVV: 'RVV' as DocumentTypesEnum,
    BCE: 'BCE' as DocumentTypesEnum,
    PLANCAD: 'PLAN_CAD' as DocumentTypesEnum,
    DOCSYNDIC: 'DOC_SYNDIC' as DocumentTypesEnum,
    ACTEBASE: 'ACTE_BASE' as DocumentTypesEnum,
    ANNEXBASE: 'ANNEX_BASE' as DocumentTypesEnum,
    ETATLIEUX: 'ETAT_LIEUX' as DocumentTypesEnum,
    GARANTIELOC: 'GARANTIE_LOC' as DocumentTypesEnum,
    ACTEHEREDITE: 'ACTE_HEREDITE' as DocumentTypesEnum,
    DEMANDERU: 'DEMANDE_RU' as DocumentTypesEnum,
    DECLASUCC: 'DECLA_SUCC' as DocumentTypesEnum,
    PERMISURB: 'PERMIS_URB' as DocumentTypesEnum,
    PERMISENV: 'PERMIS_ENV' as DocumentTypesEnum,
    REGBENEF: 'REG_BENEF' as DocumentTypesEnum,
    MAATREGELEN: 'MAATREGELEN' as DocumentTypesEnum,
    ARREC: 'AR_REC' as DocumentTypesEnum,
    LETTREVENTE: 'LETTRE_VENTE' as DocumentTypesEnum,
    ANB: 'ANB' as DocumentTypesEnum,
    SCHEMAUNIF: 'SCHEMA_UNIF' as DocumentTypesEnum,
  };
}
